export default __webpack_public_path__ + "static/media/video-library.5f37400a.svg";